import { gql } from "@apollo/client";

export const FETCH_STOCK_CATEGORY_BASIC_INFO = gql`
  query FETCH_STOCK_CATEGORY_BASIC_INFO($stockCategoryId: ID!) {
    stockCategory(id: $stockCategoryId) {
      id
      name
    }
  }
`;

export const FETCH_CREATE_STOCK_SHIPMENT_FORM_DATA = gql`
  query FETCH_CREATE_STOCK_SHIPMENT_FORM_DATA($stockCategoryId: ID!) {
    stockCategory(id: $stockCategoryId) {
      id
      name
    }
    stockCategoryLatestStocks(stockCategoryId: $stockCategoryId)
    stockCategories {
      id
      name
    }
  }
`;

export const FETCH_STOCK_SHIPMENTS = gql`
  query FETCH_STOCK_SHIPMENTS($warehouseId: ID!) {
    stockCategory(id: $warehouseId) {
      id
      name
    }
    stockShipments(warehouseId: $warehouseId, warehouseType: "STOCK_CATEGORY") {
      id
      moveType
      refType
      refName
      date
      notes
    }
  }
`;

export const FETCH_STOCK_SHIPMENT = gql`
  query FETCH_STOCK_SHIPMENT($id: ID!) {
    stockShipment(id: $id) {
      id
      odooCompanyId
      moveType
      toLocationId
      toLocationType
      refId
      refType
      refName
      date
      state
      notes
      warehouseId
      warehouseName
      warehouseType
      lines {
        id
        product {
          id
          number
          name
          countryCodeOfOrigin
          version
          itemsPerSet
        }
        qty
      }
    }
  }
`;

export const FETCH_STOCK_SHIPMENT_FORM_DATA = gql`
  query FETCH_STOCK_SHIPMENT_FORM_DATA($id: ID!, $stockCategoryId: ID!) {
    stockShipment(id: $id) {
      id
      odooCompanyId
      moveType
      toLocationId
      toLocationType
      refId
      refType
      refName
      date
      state
      notes
      warehouseId
      warehouseName
      warehouseType

      stockCategory {
        id
        name
        odooLocationId
        odooLocationName
      }
      toStockCategory {
        id
        name
        odooLocationId
        odooLocationName
      }

      odooStockPickingId
      odooStockPickingName
      lines {
        id
        product {
          id
          number
          name
          countryCodeOfOrigin
          version
          itemsPerSet
        }
        qty
      }
    }
    stockCategory(id: $stockCategoryId) {
      id
      name
    }
    stockCategories {
      id
      name
    }
    stockCategoryLatestStocks(stockCategoryId: $stockCategoryId)
  }
`;

export const SAVE_STOCK_SHIPMENT = gql`
  mutation SAVE_STOCK_SHIPMENT(
    $id: ID
    $moveType: String!
    $toLocationId: String
    $toLocationType: String
    $date: Date!
    $refId: String
    $refType: String!
    $refName: String
    $state: String!
    $notes: String
    $warehouseId: ID!
    $warehouseName: String!
    $warehouseType: String!
    $lines: [StockShipmentLineInputType]!
  ) {
    saveStockShipment(
      id: $id
      moveType: $moveType
      toLocationId: $toLocationId
      toLocationType: $toLocationType
      date: $date
      refId: $refId
      refType: $refType
      refName: $refName
      state: $state
      notes: $notes
      warehouseId: $warehouseId
      warehouseName: $warehouseName
      warehouseType: $warehouseType
      lines: $lines
    ) {
      shipment {
        id
        moveType
        toLocationId
        toLocationType
        refId
        refType
        refName
        state
        notes
        warehouseId
        warehouseName
        warehouseType
        odooStockPickingId
        odooStockPickingName
      }
    }
  }
`;

export const DELETE_STOCK_SHIPMENT = gql`
  mutation DELETE_STOCK_SHIPMENT($id: ID!) {
    deleteStockShipment(id: $id) {
      result
    }
  }
`;

export const SEND_STOCK_SHIPMENT_TO_ODOO = gql`
  mutation SendStockShipmentToOdoo($shipmentId: ID!) {
    sendStockShipmentToOdoo(shipmentId: $shipmentId) {
      shipment {
        id
        odooStockPickingId
        odooStockPickingName
      }
    }
  }
`;

export const FETCH_SHIPMENT_PRODUCTS = gql`
  query FETCH_SHIPMENT_PRODUCTS {
    products(hasOdooId: true, isSalable: true, isActive: true) {
      total
      results {
        id
        number
        name
        version
        countryCodeOfOrigin
        itemsPerSet
        images: computedImages(size: "300x300") {
          id
          url
        }
      }
    }
  }
`;

export const FETCH_STOCK_CATEGORY_LATEST_STOCKS = gql`
  query FETCH_STOCK_CATEGORY_LATEST_STOCKS(
    $stockCategoryId: ID!
    $skus: [String]
  ) {
    stockCategoryLatestStocks(stockCategoryId: $stockCategoryId)
    shopifyStocks(skus: $skus)
  }
`;

export const SHOPIFY_UPDATE_INVENTORY = gql`
  mutation SHOPIFY_UPDATE_INVENTORY(
    $instance: String!
    $items: [ShopifyUpdateStockInputType]!
    $referenceDocumentUri: String
  ) {
    shopifyUpdateStocks(
      instance: $instance
      items: $items
      referenceDocumentUri: $referenceDocumentUri
    ) {
      result
    }
  }
`;
